import axios from 'axios';
import { global } from '../config/index';
/*
 * @Description: 首页接口
 * @Author: zhangkai
 * @Date: 2020-06-15 09:17:03
 * @LastEditTime: 2020-06-17 17:36:17
 * @LastEditors: zhangkai
 */ 

// 获取书本详情
export const getBookList = (params: object) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            baseURL: global.BASE_URL,
            url: '/assistantbook-api/api/ses/assistantbook/v50/book/findbooktype',
            headers: {
                'authorization': global.BASE_TOKEN
            },
            params
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}
